import Vue from 'vue'
import VueRouter from 'vue-router'
import LoginView from "@/views/LoginView";
import Layout from "@/components/layout/Layout";

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'userLogin',
        component: LoginView
    },

    {
        path: '/',
        component: Layout,
        children: [
            {
                path: '/pending-requests',
                name: 'pending-requests',
                component: () => import(/* webpackPrefetch: true  , webpackChunkName: "pending-requests" */ '@/views/PendingRequests')
            },

            {
                path: '/agent-requests',
                name: 'agent-requests',
                component: () => import(/* webpackPrefetch: true  , webpackChunkName: "agent-requests" */ '@/views/AgentRequestsView')
            },

            {
                path: '/view-agent-request',
                name: 'view-agent-request',
                component: () => import(/* webpackPrefetch: true  , webpackChunkName: "view-agent-request" */ '@/views/AgentDataView')
            },

            {
                path: '/view-request',
                name: 'view-request',
                component: () => import(/* webpackPrefetch: true  , webpackChunkName: "view-request" */ '@/views/ClientDataView')
            },
        ]
    },

]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router
